
	$("#ue16 .ue16_2 .ue16_2_bigbox .flex").hover(function(){
		$(this).find(".imgq_pc_768").css("transform","scale(1.05)");
	},function(){
		$(this).find(".imgq_pc_768").css("transform","scale(1)");
	});
	
	
	$('#part_img_1').click(function(){
		$('html,body').animate({scrollTop:$('#part_img_1_link').offset().top - 200}, 1000);
	});
	$('#part_img_2').click(function(){
		$('html,body').animate({scrollTop:$('#part_img_2_link').offset().top - 200}, 1000);
	});
	$('#part_img_3').click(function(){
		$('html,body').animate({scrollTop:$('#part_img_3_link').offset().top - 200}, 1000);
	});
	$('#part_img_4').click(function(){
		$('html,body').animate({scrollTop:$('#part_img_4_link').offset().top - 380}, 1000);
	});
	$('#part_img_5').click(function(){
		$('html,body').animate({scrollTop:$('#part_img_5_link').offset().top - 200}, 1000);
	});
	$('#part_img_6').click(function(){
		$('html,body').animate({scrollTop:$('#part_img_6_link').offset().top - 380}, 1000);
	});
	$('#part_img_7').click(function(){
		$('html,body').animate({scrollTop:$('#part_img_7_link').offset().top -0}, 1000);
	});
	$('#part_img_8').click(function(){
		$('html,body').animate({scrollTop:$('#part_img_8_link').offset().top -250}, 1000);
	});
	
	var i = $(window).width(), n = window.innerHeight, r = i <= 1200;
	var client_width = ($(window).width());

	if (!r) {
		var ue16_6_sticky = $("#ue16 .ue16_6 .ue16_6_sticky");
	    var img_2 = $("#ue16 .ue16_6 .img_box .img_2");
	    var a_6 = gsap.timeline();
	    	a_6.to(img_2, 1, {
				opacity : "0",
	        }).to(img_2, 1, {
	        	opacity : "1",
			});
		    ScrollTrigger.create({
	            animation: a_6,
	            trigger: ue16_6_sticky,
	            scrub: !0,
	            start: "top 100%",
	            end: "bottom 120%",
	            onUpdate: function(e) {}
	        })
		    
		var title_3_sticky = $("#ue16 .title_3 .title_3_sticky");
	    var title_3 = gsap.timeline();
		    ScrollTrigger.create({
	            animation: title_3,
	            trigger: title_3_sticky,
	            scrub: !0,
	            start: "top 100%",
	            end: "bottom 100%",
	            onUpdate: function(e) {
	            }
	        })
	}
	
var ue16_9 = $(".ue16_9_act");
var ue16_10 = $(".ue16_10_act");
	active(ue16_9);
	active(ue16_10);
function active(class_name){
	var t = class_name
  , i = $(window).width()
  , n = window.innerHeight
  , r = i <= 1100;
    if (!r) {
        var a = t.find(".display_content")
          , o = a.width() - document.documentElement.clientWidth;
       		class_name.css("height", a.width());
        var s = t.find(".umx-line")
          , l = t.find(".umx-zeiss-progress")
          , d = t.find(".pro-num")
          , c = gsap.timeline();
        c.to(a, 1, {
            x: -o,
            ease: "none"
        }).to(l, .001, {
            opacity: 1
        }, "-=1"),
        ScrollTrigger.create({
            animation: c,
            trigger: t,
            scrub: !0,
            start: "top top",
            end: "bottom 110%",
            onUpdate: function(e) {
                e.progress < .50 ? d.text("1") : e.progress >= .50 && d.text("2") 
            }
        });
        
        var u = gsap.timeline();
            u.to(s, 1, {
                width: "100%"
            }),
            ScrollTrigger.create({
                animation: u,
                trigger: t,
                scrub: !0,
                start: "top top",
                end: "bottom 95%"
            })
    }
}

if(i>1200){
	let img = document.querySelector("#img_cover");
	let btn = document.querySelector("#btn_icon");
	let nav = document.querySelector(".ue16_5_2_box");
	let leftBottom = document.querySelector("#leftBottom");
	let rightBottom = document.querySelector("#rightBottom");
	btn.onmousedown = function (e) {
	    let clientx = e.clientX; // 点击获取鼠标初始X坐标
	    nav.onmousemove = function () {
	        let e = arguments[0] || window.event;
	        let X = e.clientX; // 移动时获取鼠标移动时的X坐标
	        let imgW = parseInt(getComputedStyle(img, null).width);
	        img.style.width = `${imgW + X - clientx}px`; // 图片宽度 = 移动时的X坐标 - 点击时的初始坐标 也就是 图片宽度 + 鼠标X坐标的偏移量
	        clientx = X; // 将最新的位置的X坐标 赋值给 点击初始坐标 也就是 更新 X坐标初始值
	    }
	};
	document.onmouseup = function () {
	    nav.onmousemove = null;
	}
}


$(".see_video").click(function(){
		        $(".add_alert_box").css("display","block");
		    })
			$(".add_alert_box .video_bigbox .alert_img").click(function(){
		        $(".add_alert_box").css("display","none");
		    })